import React from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend
);

export default function ReusableLineChart({
    title = "State Trend- Key inidcators",
    subtitle = "MMR & NMR (left axis), ANC 4+ (right axis)",
    labels = [],
    datasets = [],
    height = 30,
    legend = true,
    smooth = true,
}) {
    const formattedDatasets = datasets.map((ds) => ({
        label: ds.label,
        data: ds.data,
        borderColor: ds.color,
        backgroundColor: "transparent",
        fill: false,
        tension: smooth ? 0.4 : 0,
        borderWidth: 2,
        pointRadius: 3,
        /** 🔥 ANC4 or % indicators go on RIGHT Y-axis */
        yAxisID: ds.rightAxis ? "right-axis" : "left-axis",
    }));

    const data = {
        labels,
        datasets: formattedDatasets,
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
            padding: { bottom: 25 },   // 🔥 prevents label cut-off
        },
        plugins: {
            legend: {
                display: legend,
                labels: {
                    font: { size: 11 },
                    boxWidth: 12,
                },
            },
            tooltip: {
                mode: "index",
                intersect: false,
            },
            datalabels: false
        },
        scales: {
            "left-axis": {
                type: "linear",
                position: "left",
                grid: { color: "rgba(200,200,200,0.2)" },
                ticks: { font: { size: 10 } },
            },

            "right-axis": {
                type: "linear",
                position: "right",
                min: 0,
                max: 100,
                grid: { display: false },
                ticks: {
                    stepSize: 10,
                    callback: (v) => `${v}`,
                    font: { size: 10 },
                },
            },

            x: {
                grid: { display: false },
                ticks: {
                    font: { size: 10 },
                    padding: 5,   // 📌 extra space under labels
                },
            },
        },
    };


    return (
        <div
            className="w-full bg-white p-4 rounded-xl shadow-sm"
            style={{
                height: `${height}vh`,
                minHeight: "210px",   // prevent collapsing
                maxHeight: "350px",   // prevent overflow / x-axis cut
            }}
        >
            <div>
                <h3 className="text-sm font-semibold text-slate-800">{title}</h3>
                <p className="text-[11px] text-slate-500 mt-0.5">
                    {subtitle}
                </p>
            </div>
            <Line data={data} options={options} />
        </div>

    );
}
